<ng-container *ngIf="!tipoFascicolo ; else fascicoloForm">
  <app-tipi-fascicolo-widget [tipoPratica]="tipoPratica" (tipoFascicoloChange)="setTipoFascicolo($event)">
  </app-tipi-fascicolo-widget>
</ng-container>
<ng-template #fascicoloForm appInsertionHost></ng-template>
